"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetamaskSnapsSupported = exports.isPolkadotSnapInstalled = exports.hasMetaMask = void 0;
function hasMetaMask() {
    if (!window.ethereum) {
        return false;
    }
    return window.ethereum.isMetaMask;
}
exports.hasMetaMask = hasMetaMask;
function isPolkadotSnapInstalled(snapOrigin, version) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const walletSnaps = yield getWalletSnaps();
            console.info('getWalletSnaps', walletSnaps);
            return !!Object.values(walletSnaps).find((permission) => permission.id === snapOrigin && (!version || permission.version === version));
        }
        catch (e) {
            console.error('Failed to obtain installed snaps', e);
            return false;
        }
    });
}
exports.isPolkadotSnapInstalled = isPolkadotSnapInstalled;
function getWalletSnaps() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield window.ethereum.request({
            method: 'wallet_getSnaps'
        });
    });
}
function isMetamaskSnapsSupported() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield getWalletSnaps();
            return true;
        }
        catch (e) {
            return false;
        }
    });
}
exports.isMetamaskSnapsSupported = isMetamaskSnapsSupported;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsU0FBZ0IsV0FBVztJQUN6QixJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRTtRQUNwQixPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsT0FBTyxNQUFNLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQztBQUNwQyxDQUFDO0FBTEQsa0NBS0M7QUFFRCxTQUFzQix1QkFBdUIsQ0FDM0MsVUFBa0IsRUFDbEIsT0FBZ0I7O1FBRWhCLElBQUk7WUFDRixNQUFNLFdBQVcsR0FBRyxNQUFNLGNBQWMsRUFBRSxDQUFDO1lBQzNDLE9BQU8sQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLEVBQUUsV0FBVyxDQUFDLENBQUM7WUFDNUMsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxXQUFXLENBQUMsQ0FBQyxJQUFJLENBQ3RDLENBQUMsVUFBVSxFQUFFLEVBQUUsQ0FBQyxVQUFVLENBQUMsRUFBRSxLQUFLLFVBQVUsSUFBSSxDQUFDLENBQUMsT0FBTyxJQUFJLFVBQVUsQ0FBQyxPQUFPLEtBQUssT0FBTyxDQUFDLENBQzdGLENBQUM7U0FDSDtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1YsT0FBTyxDQUFDLEtBQUssQ0FBQyxrQ0FBa0MsRUFBRSxDQUFDLENBQUMsQ0FBQztZQUNyRCxPQUFPLEtBQUssQ0FBQztTQUNkO0lBQ0gsQ0FBQztDQUFBO0FBZEQsMERBY0M7QUFXRCxTQUFlLGNBQWM7O1FBQzNCLE9BQU8sTUFBTSxNQUFNLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQztZQUNuQyxNQUFNLEVBQUUsaUJBQWlCO1NBQzFCLENBQUMsQ0FBQztJQUNMLENBQUM7Q0FBQTtBQUVELFNBQXNCLHdCQUF3Qjs7UUFDNUMsSUFBSTtZQUNGLE1BQU0sY0FBYyxFQUFFLENBQUM7WUFDdkIsT0FBTyxJQUFJLENBQUM7U0FDYjtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1YsT0FBTyxLQUFLLENBQUM7U0FDZDtJQUNILENBQUM7Q0FBQTtBQVBELDREQU9DIn0=